function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.001,
    height: 88,
    viewBox: "0 0 88.001 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14434"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14431"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46918",
    d: "m412.245 208.056 5.076 1.029v7.5l-5.076-.874z",
    transform: "translate(-339.413 -172.635)",
    style: {
      fillRule: "evenodd",
      fill: "#8192a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46919",
    d: "m412.245 208.056 5.076 1.029v7.5l-1.592-.274v-7.226l-3.483-.706z",
    transform: "translate(-339.413 -172.635)",
    style: {
      fill: "#65788e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46920",
    d: "m242.221 173.58 6.386 1.295v8.4l-6.386-1.1z",
    transform: "translate(-200.181 -144.403)",
    style: {
      fillRule: "evenodd",
      fill: "#8192a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46921",
    d: "m242.221 173.58 6.386 1.295v8.4l-1.592-.275v-8.128l-4.794-.972z",
    transform: "translate(-200.181 -144.403)",
    style: {
      fill: "#65788e",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46922",
    d: "m218.04 131.1 41.724 9.488a1.077 1.077 0 0 1 .846 1.06v5.207a1.087 1.087 0 0 1-1.3 1.066l-41.724-8.212a1.078 1.078 0 0 1-.877-1.066v-6.483a1.086 1.086 0 0 1 1.328-1.059z",
    transform: "translate(-179.292 -109.592)",
    style: {
      fill: "#8ac9fe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46923",
    d: "m258.8 172.074.965.219a1.077 1.077 0 0 1 .846 1.06v5.207a1.087 1.087 0 0 1-1.3 1.066l-41.724-8.212a1.078 1.078 0 0 1-.877-1.066v-.561l40.79 8.028a1.087 1.087 0 0 0 1.3-1.066v-4.675z",
    transform: "translate(-179.292 -141.297)",
    style: {
      fill: "#60b7ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46924",
    d: "M261.857 159.594a1.446 1.446 0 0 1 .6-2.83l9.209 1.953a1.446 1.446 0 0 1-.6 2.83zm19.318 4.1a1.446 1.446 0 1 1 .6-2.83l7.985 1.694a1.446 1.446 0 0 1-.6 2.83z",
    transform: "translate(-215.322 -130.606)",
    style: {
      fill: "#eceff1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46925",
    d: "m122.727 194.418 58.292 10.515a1.8 1.8 0 0 1 1.49 1.782v39.067a1.814 1.814 0 0 1-1.811 1.811h-58.42a1.727 1.727 0 0 1-.545-.084l-4.929-1.554-3.626-45.678 8.21-5.576a1.748 1.748 0 0 1 1.339-.284z",
    transform: "translate(-94.508 -161.441)",
    style: {
      fill: "#eceff1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46926",
    d: "M198.133 461.445v3.03a1.814 1.814 0 0 1-1.811 1.811H137.9a1.727 1.727 0 0 1-.545-.084l-4.929-1.554-.171-2.15 1.1-.589 4 1.262a1.727 1.727 0 0 0 .545.084h58.419a1.814 1.814 0 0 0 1.811-1.811z",
    transform: "translate(-110.133 -380.135)",
    style: {
      fill: "#d1d1d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46927",
    d: "m262.848 328.235 29.216 2.862v26.1h-29.216z",
    transform: "translate(-217.072 -271.049)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46928",
    d: "m412.013 328.235 2.2 1.51V357.2h-2.2z",
    transform: "translate(-339.223 -271.049)",
    style: {
      fill: "#add5fa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46929",
    d: "M262.848 471.444h29.216v3.03h-29.216z",
    transform: "translate(-217.072 -388.323)",
    style: {
      fill: "#add5fa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46930",
    d: "m262.848 328.235 15.421 1.51V357.2h-15.421z",
    transform: "translate(-217.072 -271.049)",
    style: {
      fill: "#d8ecfe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46931",
    d: "m262.848 328.235 2.2 1.51V357.2h-2.2z",
    transform: "translate(-217.072 -271.049)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46932",
    d: "M262.848 471.444h15.421v3.03h-15.421z",
    transform: "translate(-217.072 -388.323)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46933",
    d: "m255.86 317.2 29.63 2.9a1.087 1.087 0 0 0 1.193-1.081v-2.129a1.083 1.083 0 0 0-.97-1.08l-29.63-3.2a1.087 1.087 0 0 0-1.2 1.081v2.428a1.084 1.084 0 0 0 .977 1.081z",
    transform: "translate(-210.547 -258.249)",
    style: {
      fill: "#9facba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46934",
    d: "m255.861 331.586 29.63 2.9a1.087 1.087 0 0 0 1.193-1.081v-2.129a1.083 1.083 0 0 0-.97-1.08l-.246-.027v1.943a1.087 1.087 0 0 1-1.193 1.081l-29.395-2.879v.189a1.084 1.084 0 0 0 .981 1.083z",
    transform: "translate(-210.547 -272.635)",
    style: {
      fill: "#8d9ca8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46935",
    d: "M16 213.386v24.746a1.787 1.787 0 0 0 1.266 1.727l24.888 7.845a1.813 1.813 0 0 0 .266.063v-53.141a1.807 1.807 0 0 0-.611.272l-25.016 16.99a1.764 1.764 0 0 0-.793 1.5z",
    transform: "translate(-14.929 -161.637)",
    style: {
      fill: "#d1d1d6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46936",
    d: "M16 418.124v3.031a1.787 1.787 0 0 0 1.266 1.727l24.888 7.845a1.809 1.809 0 0 0 .266.063v-3.03a1.813 1.813 0 0 1-.266-.063l-24.888-7.845A1.787 1.787 0 0 1 16 418.124z",
    transform: "translate(-14.929 -344.659)",
    style: {
      fill: "#b1b1b5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46937",
    d: "m62.166 335.6-11.808 2.654v18.612l11.808 3.722z",
    transform: "translate(-43.065 -277.081)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46938",
    d: "m51.995 344.369-1.637-.273v17.669l1.637.347z",
    transform: "translate(-43.065 -284.038)",
    style: {
      fill: "#add5fa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46939",
    d: "M50.358 436.287v3.031l11.808 3.722v-3.031z",
    transform: "translate(-43.065 -359.533)",
    style: {
      fill: "#add5fa",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46940",
    d: "m84.6 335.6-6.845 1.538v21.292l6.845 2.158z",
    transform: "translate(-65.503 -277.081)",
    style: {
      fill: "#d8ecfe",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46941",
    d: "m108.157 335.6-1.636 1.538v21.292l1.636 2.158z",
    transform: "translate(-89.056 -277.081)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46942",
    d: "M77.759 444.924v3.031l6.845 2.158v-3.031z",
    transform: "translate(-65.503 -366.606)",
    style: {
      fill: "#c4e2ff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46943",
    d: "m59.752 326.892-11.458 2.576a.725.725 0 0 1-.883-.707v-2.067a.716.716 0 0 1 .529-.7l11.46-3.211a.724.724 0 0 1 .92.7v2.7a.718.718 0 0 1-.568.709z",
    transform: "translate(-40.651 -266.561)",
    style: {
      fill: "#9facba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46944",
    d: "m59.752 340.777-11.458 2.576a.725.725 0 0 1-.883-.707v-2.067a.716.716 0 0 1 .529-.7l.186-.052v1.716a.725.725 0 0 0 .883.707l11.309-2.542v.36a.718.718 0 0 1-.566.709z",
    transform: "translate(-40.651 -280.446)",
    style: {
      fill: "#8d9ca8",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14432",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 990",
    cx: 19.919,
    cy: 19.919,
    r: 19.919,
    transform: "rotate(-3.151 39.83 1.095)",
    style: {
      fill: "#ffe177"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46945",
    d: "M119.917 23.823a19.919 19.919 0 1 1 0 39.837c-.451 0-.9-.016-1.342-.046a19.918 19.918 0 0 0 0-39.745c.444-.03.891-.046 1.342-.046z",
    transform: "translate(-98.928 -22.767)",
    style: {
      fill: "#ffd064",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14433"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46946",
    d: "M76.509 90.347a1.449 1.449 0 0 1 0 2.9h-15a3.29 3.29 0 0 1-1.7-6.106l-3.134-14.033h-1.7a1.449 1.449 0 1 1 0-2.9h2.855v.005a1.444 1.444 0 0 1 1.409 1.132l.838 3.747H76.6a3.163 3.163 0 0 1 3.085 3.852l-2.12 9.48a1.444 1.444 0 0 1-1.409 1.132l-14.647.005a.392.392 0 0 0 0 .784h15z",
    transform: "translate(-45.662 -59.754)",
    style: {
      fill: "#9facba",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46947",
    d: "M104.137 97.181h1.811a3.163 3.163 0 0 1 3.085 3.852l-2.12 9.48a1.444 1.444 0 0 1-1.409 1.132c-15.794.006-25.784.009-1.811 0a1.444 1.444 0 0 0 1.409-1.132l2.12-9.48a3.163 3.163 0 0 0-3.085-3.852z",
    transform: "translate(-75.01 -81.841)",
    style: {
      fill: "#8d9ca8",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12043",
    transform: "translate(.001)",
    style: {
      fill: "transparent"
    },
    d: "M0 0h88v88H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/emptyTable.4d75638e6606f9f1236045379031c8c3.svg";
export { ForwardRef as ReactComponent };